import AdminOnly from 'layout/AdminOnly';
import DashboardApi from 'api/dashboard';
import Loader from '../loader.jsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import {makeCancelable} from 'helpers/cancelablePromise';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';

class PastDueWaterAnalysis extends Component {
  static propTypes = {
    start: PropTypes.any,
    end: PropTypes.any,
    branch: PropTypes.any,
    branches: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.state = {
      report: null,
      loaded: false,
    };
  }
  componentDidMount() {
    this.onUpdate();
  }

  componentWillUnmount() {
    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }
  }

  onUpdate() {
    const {branch, branches} = this.props;
    const pastWeekStr = moment().subtract(1, 'weeks').startOf('week').format();
    const past2WeekStr = moment().subtract(2, 'weeks').startOf('week').format();
    const nextWeekStr = moment().add(1, 'weeks').startOf('week').format();
    const next2WeekStr = moment().add(2, 'weeks').startOf('week').format();

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }

    (this.fetching = makeCancelable(DashboardApi.getPastDueAnalysis(branch === -1 ? branches : branch,
      pastWeekStr, past2WeekStr, nextWeekStr, next2WeekStr)))
      .then(data => {
        this.setState({
          report: data,
          loaded: true,
        });
      })
      .catch(err => {
        console.log(err);
        this.setState({
          loaded: false,
        });
      });
  }
  render() {
    const {report, loaded} = this.state;
    const {timeframe} = this.props;

    return <div className='past-due-report expanded-tile'>
      {report ?
        <Loader loaded={loaded}>
          <div className='row'>
            <div className='col-sm-12'>
              <div className='report-header'>
                <h2 className='title'><FormattedMessage id="posdashboard.pastdue.water.analysis"/></h2>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-12 col-md-6'>
              <p>
                <FormattedMessage id="posdashboard.pastdue.missed.analysis"/>
              </p>
              <table className="table table-striped table-biolab">
                <thead>
                  <tr>
                    <th><FormattedMessage id="posdashboard.pastdue.since"/></th>
                    <th><FormattedMessage id="posdashboard.total.customers"/></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <FormattedMessage id="general.yesterday"/>
                    </td>
                    <td>
                      {report.yesterdayCount}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <FormattedMessage id="general.last.week"/>
                    </td>
                    <td>
                      {report.pastWeekCount}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <FormattedMessage id="general.last.two.weeks"/>
                    </td>
                    <td>
                      {report.past2WeeksCount}
                    </td>
                  </tr>
                  {timeframe !== 'week' ?
                    <tr>
                      <td>
                        <FormattedMessage id="general.last.thirty.days"/>
                      </td>
                      <td>
                        {report.past30DaysCount}
                      </td>
                    </tr> :
                  null}
                  {timeframe === 'year' ?
                    <tr>
                      <td>
                        <FormattedMessage id="general.last.twelve.months"/>
                      </td>
                      <td>
                        {report.past12MonthsCount}
                      </td>
                    </tr> :
                  null}
                </tbody>
              </table>
            </div>
            <div className='col-sm-12 col-md-6'>
              <p>
                <FormattedMessage id="posdashboard.upcoming.water.analysis"/>
              </p>
              <table className="table table-striped table-biolab">
                <thead>
                  <tr>
                    <th><FormattedMessage id="posdashboard.future.due"/></th>
                    <th><FormattedMessage id="posdashboard.total.customers"/></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <FormattedMessage id="general.today"/>
                    </td>
                    <td>
                      {report.currentDayCount}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <FormattedMessage id="general.next.week"/>
                    </td>
                    <td>
                      {report.nextWeekCount}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <FormattedMessage id="general.next.two.weeks"/>
                    </td>
                    <td>
                      {report.next2WeeksCount}
                    </td>
                  </tr>
                  {timeframe !== 'week' ?
                    <tr>
                      <td>
                        <FormattedMessage id="general.next.thirty.days"/>
                      </td>
                      <td>
                        {report.next30DaysCount}
                      </td>
                    </tr> :
                  null}
                  {timeframe === 'year' ?
                    <tr>
                      <td>
                        <FormattedMessage id="general.next.twelve.months"/>
                      </td>
                      <td>
                        {report.next12MonthsCount}
                      </td>
                    </tr> :
                  null}
                </tbody>
              </table>
            </div>
          </div>
        </Loader> :
        <div/>
      }
    </div>;
  }
}

export default bindLocaleUpdate(PastDueWaterAnalysis);
